var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[(_vm.list[_vm.ad])?[_c('p',{staticClass:"img",style:({backgroundImage: 'url(' + _vm.list[_vm.ad].img + ')'})}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.list[_vm.ad].title))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-671d1762","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/ad.vue
// module id = OQkG
// module chunks = 1